import apiClient from "../../utils/apiclient";


export const activityLog=async(reqBody:{
    key: string;
    fromdate: string;
    todate : string;
    page: number;
    limit: number;
    
},token:string)=>{
   return await apiClient.post('/activity/get-logs',reqBody, {
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}

